export default "__VITE_ASSET__BF3L3_gf__"